import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ chapter, overline, title, align = "left" }) => (
  <div className={`mb-16 md:mb-24 ${align === "center" ? "text-center" : ""}`} data-testid={`section-heading-${chapter}`}>
    <Reveal>
      <div className={`flex items-baseline gap-4 ${align === "center" ? "justify-center" : ""}`}>
        <span className="font-mono text-xs text-gold tracking-[0.3em]">{chapter}</span>
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">{overline}</span>
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="font-display text-[clamp(2.1rem,4.5vw,3.75rem)] font-bold tracking-tight mt-4 text-zinc-50">
        {title}
      </h2>
    </Reveal>
  </div>
);
